import { Group } from "@mantine/core"

import type { LibraryResponses } from "@tfg/types/endpoints/library"

import { CustomFieldTreeBranch } from "~/pages/Brand/Products/Details/CustomFieldGraph/CustomFieldTreeBranch"
import type { CustomFieldTreeSectionProps } from "~/pages/Brand/Products/Details/CustomFieldGraph/custom-field-graph.types"
import {
  getCustomFieldDefinitionsForItem,
  getProductActivityIds,
} from "~/pages/Brand/Products/Details/CustomFieldGraph/custom-field-graph.utils"

type Props = CustomFieldTreeSectionProps & {
  readonly material: LibraryResponses.EnrichedMaterial
}

export const CustomFieldMaterialTree = ({
  product,
  material,
  getOperations,
  originCue,
}: Props) => {
  const productActivityIds = getProductActivityIds(product)

  return (
    <Group gap={0} align="flex-start" wrap="nowrap">
      <CustomFieldTreeBranch
        customFieldsDefs={getCustomFieldDefinitionsForItem(
          product,
          material.item,
          productActivityIds
        )}
        hideFirstDivider={true}
        item={material.item}
        operations={getOperations(material.item)}
        originCue={originCue}
      />
    </Group>
  )
}
